<template>
  <div class="flex min-h-screen items-center justify-center">
    <div v-if="denied">
      <h2>Login Failed</h2>
      <p>You must grant the members hub access to your Nurtur account.</p>
      <div class="flex justify-end">
        <button @click="start">
          Try Again
        </button>
      </div>
    </div>
    <div v-if="failed">
      <h2>Login Failed</h2>
      <p>{{ failed }}</p>
      <div class="flex justify-end">
        <button @click="start">
          Try Again
        </button>
      </div>
    </div>
    <loader v-else fill-colour="white" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      denied: this.$route.query.error === 'access_denied',
      failed: null
    }
  },
  created () {
    if (this.denied) {
      return
    }

    this.init()
  },
  methods: {
    ...mapActions(['bootSystem', 'requestAuthorization', 'getToken', 'fetchSystem']),
    async init () {
      const state = this.$route.query.state
      const code = this.$route.query.code
      const intended = localStorage.intended || '/'
      if (!code) {
        return this.start(this.$route.query.force !== '0' && this.$route.query.referrer !== 'ecosystem', this.$route.query.referrer === 'ecosystem')
      }

      try {
        await this.fetchSystem()
        await this.getToken({ state, code })
      } catch (e) {
        this.failed = e
        return
      }
      await this.bootSystem()
      localStorage.removeItem('intended')
      this.$router.replace(intended.indexOf('?') === 0 ? '/' : intended)
    },
    start (force, direct) {
      return this.requestAuthorization({ force, direct })
    }
  }
}
</script>
